<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <g clip-path="url(#clip0_6182_7358)">
    <path d="M12.0492 20.2969V11.1746H15.1099L15.5691 7.61844H12.0492V5.34834C12.0492 4.31907 12.3338 3.61764 13.8115 3.61764L15.693 3.61687V0.436105C15.3676 0.39382 14.2507 0.296875 12.9507 0.296875C10.2361 0.296875 8.37764 1.95384 8.37764 4.99614V7.61844H5.30762V11.1746H8.37764V20.2969H12.0492Z" fill="#2E5FE3"/>
  </g>
  <defs>
    <clipPath id="clip0_6182_7358">
      <rect width="20" height="20" fill="white" transform="translate(0.5 0.296875)"/>
    </clipPath>
  </defs>
</svg>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>